import moment from 'moment-timezone';

const timeTooltipPlugin = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.timeTooltip = date => {
      return moment(date).format('ddd, hh:mm');
    };
  },
};

export default timeTooltipPlugin;
